import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("emlak_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("emlak_token");
  }
};

const existing = localStorage.getItem("emlak_token");
if (existing) {
  api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;
}

export const getToken = () => localStorage.getItem("emlak_token") || "";

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu, tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (fileId, v) => `${API}/files/${fileId}?auth=${getToken()}${v ? `&v=${v}` : ""}`;

export const ROLE_LABEL = {
  SUPER_ADMIN: "Süper Yönetici",
  REPRESENTATIVE: "Temsilci",
  PLATFORM_ACCOUNTANT: "Platform Muhasebe",
  BROKER: "Broker (Ofis Yöneticisi)",
  ACCOUNTANT: "Muhasebe",
  CONSULTANT: "Danışman",
};

export const PLATFORM_ROLES = ["SUPER_ADMIN", "REPRESENTATIVE", "PLATFORM_ACCOUNTANT"];

export const ROLE_COLOR = {
  SUPER_ADMIN: "bg-purple-500/10 text-purple-700 border-purple-500/30",
  REPRESENTATIVE: "bg-indigo-500/10 text-indigo-700 border-indigo-500/30",
  PLATFORM_ACCOUNTANT: "bg-cyan-500/10 text-cyan-700 border-cyan-500/30",
  BROKER: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30",
  ACCOUNTANT: "bg-blue-500/10 text-blue-700 border-blue-500/30",
  CONSULTANT: "bg-amber-500/10 text-amber-700 border-amber-500/30",
};

export const PACKAGE_STYLE = {
  STANDARD: "bg-slate-100 text-slate-700 border-slate-300",
  SILVER: "bg-zinc-200 text-zinc-800 border-zinc-400",
  GOLD: "bg-amber-100 text-amber-800 border-amber-400",
};

export const SUB_STATUS = {
  ACTIVE: { label: "Aktif", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  WARNING: { label: "Süre Doluyor", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  FROZEN: { label: "Donduruldu", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
};

export const PAYMENT_STATUS = {
  PAID: "Ödendi",
  DUE: "Ödeme Bekleniyor",
  OVERDUE: "Ödenmedi",
};

export const formatDate = (s) => (s ? new Date(s).toLocaleDateString("tr-TR") : "-");

export const formatTL = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);

export const compactNumber = (n) => new Intl.NumberFormat("tr-TR", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);
